import WidgetBase from '../widget.base';
import featSniffer from 'App/lib/featureDetection';
import { each } from 'App/lib/dom';

export default class CompoundCalloutListWidget extends WidgetBase {
    static selector = '[data-ww-compound-callout-list]';
    slideContainer;
    circleBG;
    sections;
    pagerWidth;
    navCircles;
    navContainer;
    threshold = 100;
    isUpdatingTouch = false;
    mobileBP = 480;
    calloutObj;
    slides;
    _index;

    constructor(el){
        super(el);
        this.sections = this.el.querySelectorAll('[data-section]');
        this.circleBG = this.el.querySelectorAll('[data-circle-bg]');
        this.createCalloutObj();
        window.addEventListener('resize', this.adjustCircleSize.bind(this));
        this.adjustCircleSize();
        setTimeout(() => this.loaded());
    }

    adjustCircleSize(){
        each(this.circleBG, (el) => {
            const height = el.offsetHeight;
            el.style.width = `${height}px`;
        });
    }

    createCalloutObj(){
        this.calloutObj = [];
      
        for(let i = 0; i < this.sections.length; i++){
            let obj = {};
            obj.index = 0;
            obj.slides = this.sections[i].querySelectorAll(['[data-slide]']);
            obj.navCircles = this.sections[i].querySelectorAll('[data-nav-circle]');
            obj.navContainer = this.sections[i].querySelector('[data-nav-container]');
            obj.slideContainer = this.sections[i].querySelector('[data-slide-container]');
            obj.slideContainer.style.transform = "translateX(0px)";
            obj.calloutContainer = this.sections[i].querySelector('[data-callout-container]');
            obj.mainCallout = this.sections[i].querySelectorAll('[data-js-main]');
            if((obj.slides.length === 0 && obj.mainCallout.length === 1) || obj.slides.length === 1){
                if(this.isMobile()){
                    obj.calloutContainer.style.position = "relative";
                    obj.calloutContainer.style.top = "0";
                    obj.calloutContainer.style.transform="translateY(0)";
                } else{
                    obj.calloutContainer.style.position = "absolute";
                    obj.calloutContainer.style.top = "50%";
                    obj.calloutContainer.style.left = "50%";
                    obj.calloutContainer.style.transform="translateX(-50%) translateY(-50%)";
                }
            }
            if(obj.slides.length == 0){
               
            } else{
                obj.slides[0].classList.add('active');
            }
            obj.slideContainer.addEventListener("transitionend", (e) => {
                e.target.classList.remove('transition-container');
            });
            if(featSniffer.touch() && obj.slides.length > 1){
                this.addTouchEvents(obj.slideContainer, i);
            }

         

    
           
            this.calloutObj.push(obj);
        }
    }

    //modifyCSS(collection){
         //collection.circleBackground.style.position="relative";
        // collection.circle.style.left = "null";
         //collection.circle.style.position="absolute";
         //collection.circle.style.left = "unset";
         //collection.circle.style.width="auto";
         //collection.headerContainer.style.position="absolute";

         //collection.contentContainer.style.justifyContent="center";
        // collection.headerContainer.style.top = "0";
    //}

    removeTransition = () => {
        this.slideContainer.classList.remove('transition-container');
    }

    setTransformX(el, value) {
        el.style.transform = 'translate3d(' + value + 'px, 0, 0)';
    }



    update(oldIdx, collection) {
        let currentIdx = collection.index;

        if(collection.slides[currentIdx] == null){
            return;
        }
        if(collection.slides[oldIdx] == null){
            return;
        }
        if(typeof oldIdx !== 'undefined') {
            collection.slides[oldIdx].classList.remove('active');
            collection.navCircles[oldIdx].classList.remove('active');
            
        }

        collection.slides[currentIdx].classList.add('active');
        collection.navCircles[currentIdx].classList.add('active');
        
        let slideWidth = collection.slides[currentIdx].offsetWidth;
        const newOpacity = (slideWidth * 3) > window.innerWidth ? 0.7 : 1;        
        const offset = 30; //initial offset. how far the first slide is indented
        // const marginOffset = 5; //margin of 10. divide it by 2
        // let gutter = (collection.slideContainer.offsetWidth / collection.slides.length) * currentIdx;
        // gutter -= (currentIdx * marginOffset);
        // gutter *= -1;
        // gutter += offset;
        let gutter = slideWidth * currentIdx * -1;
        const marginOffset = window.screen.width <= 325 ? 15 : 30;
        const slideoff = ((window.screen.width - slideWidth) / 2) - marginOffset - (currentIdx * 10);
        gutter += slideoff;
        
       // if(oldIdx === 0){
            // gutter -= offset / 2;
       // } else {
            // gutter -= (10 * currentIdx);
        //}
        // const gutter =  ((collection.slideContainer.offsetWidth / collection.slides.length) * currentIdx - (5 * currentIdx)) * -1;  //slideWidth * currentIdx * -1; //(window.innerWidth - this.slideWidth);    

        if(currentIdx === 0) {
            this.setTransformX(collection.slideContainer, 0)
        }else{
            this.setTransformX(collection.slideContainer, gutter)
        }

    }

    addTouchEvents(element, collectionIdx){
        let isTouchStart = false;

        // initial mouse X for `mousedown`
        let touchX;
        let touchY;

        // element transform style before/after
        let transformX;

        // element X before and after move
        let elementX = 0;

        element.addEventListener('touchstart', onTouchStart.bind(this));
        
        /**
         * Listens to `mousedown` event.
         *
         * @param {Object} event - The event.
         */
        function onTouchStart(event) {
            if(!this.isMobile()){
                return;
            }
          
  
            element.classList.add('dragging');
            touchX = event.touches[0].clientX;
            touchY = event.touches[0].clientY;
            isTouchStart = true;

            transformX = parseTransformX(element.style.transform);
        }
    
        // mouse button released
        element.addEventListener('touchend', onTouchEnd.bind(this));
    
        /**
         * Listens to `mouseup` event.
         *
         * @param {Object} event - The event.
         */
        function onTouchEnd(event) {
            if(!this.isMobile()){
                return;
            }
          
            let oldIdx = this.calloutObj[collectionIdx].index;
            element.classList.remove('dragging');
            element.classList.add('transition-container');
            elementX = element.style.transform ? parseTransformX(element.style.transform) : transformX;
            
            const transformDelta = elementX - transformX;
            
            if (Math.abs(transformDelta) > this.threshold) {
                if(transformDelta < 0) {
                    if(oldIdx !== this.calloutObj[collectionIdx].slides.length - 1) {
                        this.calloutObj[collectionIdx].index++;
                        this.isUpdatingTouch = true;
                        this.update(oldIdx, this.calloutObj[collectionIdx]);

                    }else{
                        // sets slide back to start position
                        element.style.transform = 'translate3d(' + transformX + 'px, 0, 0)';        
                    }
                }else{
                    if(oldIdx !== 0) {
                        this.calloutObj[collectionIdx].index--;
                        this.update(oldIdx, this.calloutObj[collectionIdx]);
 
                    }else{
                        // sets slide back to start position
                        element.style.transform = 'translate3d(' + transformX + 'px, 0, 0)';        
                    }
                }
            }else{
                element.style.transform = 'translate3d(' + transformX + 'px, 0, 0)';

                if (this.activatingIndex) {
                }
            }
            
          
        }

        function parseTransformX(transform) {
            return parseInt(transform.split('(')[1].split(',')[0])
        }

        element.addEventListener('touchmove', onTouchMove.bind(this));

        function onTouchMove(event) {
            if (!isTouchStart) return;
            
            var deltaX = event.touches[0].clientX - touchX;
            var deltaY = event.touches[0].clientY - touchY;
 
            const absDeltaX = Math.abs(deltaX);
            const absDeltaY = Math.abs(deltaY);

            if(absDeltaY > absDeltaX) {
                return false;
            }
            element.style.transform = 'translate3d(' + (transformX + deltaX) + 'px, 0, 0)';
            event.preventDefault();
        }
    }

    ratioUtility(delta, max) {
        const ratio = delta * max;
        return ratio < max ? ratio : max;
    }
    
    isMobile(){
        let browserWidth = window.innerWidth;
        return (browserWidth <= this.mobileBP);
    }
}